import type { ClaimAnalysisResponse } from '../types/claim-analysis';

/**
 * OAR 缓存服务接口
 *
 * 提供权利要求分析结果的缓存功能，避免重复的昂贵异步请求
 */
export interface OarCacheService {
    /**
     * 获取缓存的权利要求分析结果
     *
     * @param cacheKey - 缓存键，格式为 `${taskId}:${conclusiveOpinionId}`
     * @returns 缓存的分析结果，如果不存在或已过期则返回 null
     */
    get(cacheKey: string): ClaimAnalysisResponse | null;

    /**
     * 设置权利要求分析结果缓存
     *
     * @param cacheKey - 缓存键，格式为 `${taskId}:${conclusiveOpinionId}`
     * @param data - 分析结果数据
     * @param ttlMs - 缓存过期时间（毫秒），默认 15 分钟
     */
    set(cacheKey: string, data: ClaimAnalysisResponse, ttlMs?: number): void;

    /**
     * 删除指定的缓存项
     *
     * @param cacheKey - 缓存键
     */
    delete(cacheKey: string): void;

    /**
     * 清空所有缓存
     */
    clear(): void;

    /**
     * 检查缓存项是否存在且未过期
     *
     * @param cacheKey - 缓存键
     * @returns 是否存在有效的缓存
     */
    has(cacheKey: string): boolean;

    /**
     * 获取缓存项数量
     *
     * @returns 当前缓存项数量
     */
    size(): number;
}

/**
 * OAR 缓存服务依赖注入符号
 */
export const OarCacheService = Symbol.for('OarCacheService');
